import { Divider, Grid } from "@mui/material";
import { useState } from "react";
import { useSelector } from "react-redux";
import PageHeader from "../../components/UI/Headers/PageHeader/PageHeader";
import CustomTabs from "../../components/UI/Tabs/CustomTabs/CustomTabs";
import { TabItemEntity } from "../../entities/UIEntities/TabItem";
import { ROLES_HIERARCHY, TABLES } from "../../enums/Enums";
import useMessagingService from "../../hooks/useMessagingService";
import { commonActions } from "../../redux/reducers/CommonReducer";
import { userActions } from "../../redux/reducers/UserReducer";
import store from "../../redux/Store";
import Icons from "../../resources/icons/Icons";
import Strings from "../../resources/Strings";
import classes from "../Parkers/ParkersPage.module.css";
import MessagingInfo from "../UserInfo/SideWindowInfo/MessagingInfo";
import AddCampaignForm from "../../components/UI/Forms/Wizard Forms/AddForms/AddCampaignForm";
import AddMailingListForm from "../../components/UI/Forms/Wizard Forms/AddForms/AddMailingListForm";
import { messagingActions } from "../../redux/reducers/MessagingReducer";

const MessagingPage = () => {
  const gmtUser = useSelector((state) => state.user.gmtUser);
  const [tableName, setTableName] = useState(Strings.TABS_NAMES.CAMPAIGNS);
  let tabs = [];
  const showUserInfoWindow = useSelector((state) => {
    return state.user?.showUserInfoWindow;
  });

  const selectionModel = useSelector((state) => state.messaging.messagingSelectionModel);

  const { getCampaignDataTable, getMessagingHistoryTable, getMailingListsTable } = useMessagingService();

  const onRowClick = (selectionModel) => {
    const isNotEmptyModel = Object.keys(selectionModel).length !== 0;
    store.dispatch(messagingActions.setMessagingSelectionModel(selectionModel));
    if (isNotEmptyModel) {
      store.dispatch(userActions.setShowUserInfoWindow(true));
    }
  };

  let campaignsTab = new TabItemEntity(
    Strings.TABS_NAMES.CAMPAIGNS,
    TABLES.CAMPAIGNS,
    getCampaignDataTable(onRowClick)
  );

  let messagingHistoryTab = new TabItemEntity(
    Strings.TABS_NAMES.MESSAGING_HISTORY,
    TABLES.MESSAGING_HISTORY,
    getMessagingHistoryTable(onRowClick)
  );

  let mailingListsTab = new TabItemEntity(
    Strings.TABS_NAMES.MAILING_LISTS,
    TABLES.MAILING_LIST,
    getMailingListsTable(onRowClick)
  );

  tabs = [campaignsTab, messagingHistoryTab, mailingListsTab];

  const handleTabChanged = (tableName) => {
    setTableName(tableName);
  };

  const handleCloseEvent = () => {
    store.dispatch(userActions.setShowUserInfoWindow(false));
  };

  const handleModalOpen = () => {
    if (tableName === Strings.TABS_NAMES.CAMPAIGNS) {
      store.dispatch(
        commonActions.setSideModal({ modalContent: <AddCampaignForm campaignData={selectionModel} /> })
      );
    }
    else {
      store.dispatch(
        commonActions.setSideModal({ modalContent: <AddMailingListForm mailingListData={selectionModel} /> })
      );
    }
    
  };

  return (
    <div className={classes.parkersPage}>
      <Grid container spacing={4} className={classes.parkersContainer}>
        <Grid xs={12} item className={classes.item}>
          <PageHeader
            icon={Icons.GMT_HEADER}
            pageTitle={Strings.TITLES.MESSAGING_PAGE}
            buttonText={tableName === Strings.TABS_NAMES.CAMPAIGNS ? Strings.ADD_CAMPAIGN : Strings.ADD_MAILING_LIST}
            disableDisplay={tableName === Strings.TABS_NAMES.MESSAGING_HISTORY}
            validRole={
              gmtUser?.role?.hierarchy <= ROLES_HIERARCHY.ADMINISTRATOR
            }
            handleModalOpen={handleModalOpen}
          />
          {tabs && (
            <CustomTabs
              initialTab={Strings.TABS_NAMES.CAMPAIGNS}
              tabs={tabs}
              onTabChange={handleTabChanged}
            ></CustomTabs>
          )}
        </Grid>
        {showUserInfoWindow && selectionModel && (
          <Divider orientation="vertical" flexItem></Divider>
        )}
        {showUserInfoWindow && selectionModel && (
          <Grid xs={5} item className={classes.item}>
            <MessagingInfo
              {...selectionModel}
              handleCloseEvent={handleCloseEvent}
              tableName={tableName}
              validRole={
                gmtUser?.role?.hierarchy <= ROLES_HIERARCHY.ADMINISTRATOR
              }
            ></MessagingInfo>
          </Grid>
        )}
      </Grid>
    </div>
  );
};

export default MessagingPage;
